module.exports = __webpack_public_path__ + "static/img/box-close.4428b4b0.png";